import React from "react";
import ReactPaginate from "react-paginate";
import { useDispatch } from "react-redux";

function CustomPagination({
  totalCount,
  perPageData,
  searchFilter,
  setSearchFilter,
  apiCall,
  IsPayoutStatus

}) {
  const dispatch = useDispatch();

  const handlePageClick = async (event) => {
    await setSearchFilter({
      ...searchFilter,
      page: event.selected + 1,
    });
    await dispatch(apiCall({ ...searchFilter, page: event.selected + 1,"IsPayoutStatus":IsPayoutStatus}));
  };

  return (
    <>
      <ReactPaginate
        breakLabel="..."
        nextLabel={totalCount > perPageData ? "Next >" : ""}
        onPageChange={handlePageClick}
        pageRangeDisplayed={perPageData}
        pageCount={Math.ceil(totalCount / perPageData)}
        previousLabel={totalCount > perPageData ? "< Previous" : ""}
        renderOnZeroPageCount={null}
        breakClassName={"page-item"}
        breakLinkClassName={"page-link"}
        containerClassName={"pagination"}
        pageClassName={"page-item"}
        pageLinkClassName={"page-link"}
        previousClassName={"page-item"}
        previousLinkClassName={totalCount > perPageData ? "page-link" : ""}
        nextClassName={"page-item"}
        nextLinkClassName={totalCount > perPageData ? "page-link" : ""}
        activeClassName={"active"}
        forcePage={searchFilter?.page - 1}
      />
    </>
  );
}

export default CustomPagination;
